import { ref, type Ref } from 'vue'

function readStoredValue<T>(key: string, defaultValue: T): T {
  try {
    const stored = localStorage.getItem(key)
    return stored ? JSON.parse(stored) : defaultValue
  } catch {
    return defaultValue
  }
}

export function useStorage<T>(key: string, defaultValue: T): [Ref<T>, (value: T) => void] {
  const state = ref<T>(readStoredValue(key, defaultValue)) as Ref<T>

  const setValue = (value: T) => {
    try {
      state.value = value
      localStorage.setItem(key, JSON.stringify(value))
    } catch (error) {
      console.warn(`Could not save to localStorage for key "${key}":`, error)
    }
  }

  return [state, setValue]
}